import { init, browserTracingIntegration } from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

// const SENTRY_DSN = process?.env?.SENTRY_DSN || "";
// const ENV_SUBFIX = process?.env?.ENV_SUBFIX ?? "local";

declare global {
  interface Window {
    ENV: {
      SENTRY_DSN: string;
      ENV_SUBFIX: string;
    };
  }
}

const SENTRY_DSN = window?.ENV?.SENTRY_DSN || "";
const ENV_SUBFIX = window?.ENV?.ENV_SUBFIX ?? "local";
const SENTRY_ENV = `front-${ENV_SUBFIX}`;

if (!SENTRY_DSN) {
  console.warn("SENTRY_DSN is not set. Sentry will not be initialized.");
} else {
  const sentryConfiguration = {
    dsn: SENTRY_DSN,
    tracesSampleRate: 1,
    environment: SENTRY_ENV,
    integrations: [
      browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
    ],
  };
  console.log("Sentry initialized");
  console.log("Full configuration:", sentryConfiguration);
  init(sentryConfiguration);
}
startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});
